import { useState } from 'react'
import { Link } from 'react-router-dom'

import Toggle from '../assets/icons/toggle.svg'
import ToggleChecked from '../assets/icons/toggle-checked.svg'

export default function Contact() {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <div className='wrapper '>
      {/* 1분 문답 - 메인 */}
      <div
        className='flex flex-col items-center justify-center bg-center bg-no-repeat bg-cover gap-[56px] h-[calc(100vh-60px)]'
        style={{
          backgroundImage: 'url(' + require('assets/images/contact-1minute_background.png') + ')',
        }}
      >
        <div className='container flex items-center justify-center px-20 mx-auto 2xs:px-0'>
          <div className='flex flex-col gap-40'>
            <p className='items-start text-title3-bold 2xs:text-title2-bold sm:text-title1-bold text-sk-disable'>
              간결하고 꼼꼼한 SW 솔루션
              <br />
              시그마테크놀로지와 함께하세요
            </p>
            <div className='flex flex-col gap-10'>
              <div className='rounded-8'>
                <p className='py-20 pl-20 pr-12 text-body1-medium text-neutral-60 bg-neutral-99 md:min-w-[700px] lg:w-[900px] xl:w-[1024px] h-[350px] rounded-8 overflow-y-auto box'>
                  시그마테크놀로지(주)(이하 “회사”)는 정보통신망 이용촉진 및 정보보호 등에 관한
                  법률, 개인정보 보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가
                  준수하여야 할 관련 법규상의 개인정보보호 규정을 준수하며, 관련 법령에 따른
                  이용자의 권익 보호에 최선을 다하고 있습니다. <br /> <br />
                  회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제27조의2에 따라 정보주체의
                  개인정보를 보호하고 개인정보 관련 문제를 신속하고 원활하게 처리할 수 있도록 하기
                  위하여 다음과 같이 개인정보 처리방침을 운영합니다. <br /> <br />
                  1. 개인정보의 수집 및 이용목적 회원의 취업과 인재채용 활동을 매개하는 온라인
                  리크루팅 사이트인 코워커(이하 "사이트")은 효과적인 취업지원 · 인재채용 · 경력개발
                  · 공모전 · 공모사업에 적합한 서비스를 제공하기 위하여 개인정보를 수집하고 있으며
                  수집된 정보를 아래와 같이 이용하고 있습니다. 이용자가 제공한 모든 정보는 하기
                  목적에 필요한 용도 이외로는 사용되지 않으며 이용 목적이 변경될 시에는 사전 동의를
                  구할 것입니다. 시그마테크놀로지(주)(이하 “회사”)는 정보통신망 이용촉진 및 정보보호
                  등에 관한 법률, 개인정보 보호법, 통신비밀보호법, 전기통신사업법 등
                  정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정을 준수하며,
                  관련 법령에 따른 이용자의 권익 보호에 최선을 다하고 있습니다. <br /> <br />
                  회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제27조의2에 따라 정보주체의
                  개인정보를 보호하고 개인정보 관련 문제를 신속하고 원활하게 처리할 수 있도록 하기
                  위하여 다음과 같이 개인정보 처리방침을 운영합니다. <br /> <br />
                  1. 개인정보의 수집 및 이용목적 회원의 취업과 인재채용 활동을 매개하는 온라인
                  리크루팅 사이트인 코워커(이하 "사이트")은 효과적인 취업지원 · 인재채용 · 경력개발
                  · 공모전 · 공모사업에 적합한 서비스를 제공하기 위하여 개인정보를 수집하고 있으며
                  수집된 정보를 아래와 같이 이용하고 있습니다. 이용자가 제공한 모든 정보는 하기
                  목적에 필요한 용도 이외로는 사용되지 않으며 이용 목적이 변경될 시에는 사전 동의를
                  구할 것입니다.
                </p>
              </div>
              <div
                className='flex gap-16 p-16 cursor-pointer'
                onClick={() => setIsChecked((prev) => !prev)}
              >
                <img src={isChecked ? ToggleChecked : Toggle} alt='' />
                <p className='text-body1-semibold 2xs:text-h2-semibold text-sk-white'>
                  개인정보 보호정책에 동의합니다
                </p>
              </div>
            </div>
          </div>
        </div>
        <Link to='/contact/qnas'>
          <button className='px-48 py-12 button_white text-body1-medium' disabled={!isChecked}>
            시작
          </button>
        </Link>
      </div>
    </div>
  )
}
